import { SOURCE_MAPPINGS } from '../models/source.model';
var SourceComponent = /** @class */ (function () {
    function SourceComponent() {
        this.compact = false;
        this._clsSource = true;
    }
    Object.defineProperty(SourceComponent.prototype, "valid", {
        get: function () {
            return SOURCE_MAPPINGS.has(this.source);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceComponent.prototype, "abbr", {
        get: function () {
            var source = SOURCE_MAPPINGS.get(this.source);
            return source ? source.abbr : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceComponent.prototype, "text", {
        get: function () {
            var source = SOURCE_MAPPINGS.get(this.source);
            return source ? source.text : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceComponent.prototype, "tooltip", {
        get: function () {
            if (!this.compact) {
                return '';
            }
            var source = SOURCE_MAPPINGS.get(this.source);
            return source ? source.tooltip : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceComponent.prototype, "url", {
        get: function () {
            var source = SOURCE_MAPPINGS.get(this.source);
            return source ? source.url : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceComponent.prototype, "cls", {
        get: function () {
            var abbr = this.abbr;
            if (!abbr) {
                return '';
            }
            return 'source__wrapper source__wrapper--' + abbr.toLowerCase().replace(/[^a-zA-Z0-9-_]/g, '');
        },
        enumerable: true,
        configurable: true
    });
    return SourceComponent;
}());
export { SourceComponent };
